import Table from "@/common/components/Table";
import { ChevronLeft } from "lucide-react";
import { defaultColumns } from "../constants/columns.constants";
import Button from "@/common/components/Button";
import { formatCurrency } from "@/common/utils/formatters";
import { ConsumptionValidationSchema } from "../schemas/create.schema";
import { FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import Spinner from "@/common/components/Spinner";
import { UnitTextField } from "@/common/components/UnitTextField";
import { unitStrategy } from "@/features/privateCompanies/constants/unitStrategy.constant";

interface TabResumeProps {
  activeTab: number;
  handleTabChange: (tabIndex: number) => void;
  register: UseFormRegister<ConsumptionValidationSchema>;
  watch: UseFormWatch<ConsumptionValidationSchema>;
  errors?: FieldErrors<ConsumptionValidationSchema>;
  isPending: boolean;
}

const TabResume = ({ activeTab, handleTabChange, watch, register, errors, isPending }: TabResumeProps) => {
  const watchTotalAmount = watch("total_amount");
  const watchProducts = watch("line_items_attributes");
  const card_type = watch("card_type");
  const category_bypass_consumption_usage_validations = watch("category_bypass_consumption_usage_validations");

  return (
    <>
      <div className="flex flex-col gap-6 grow max-h-[calc(100vh-192px)] overflow-hidden">
        <div data-testid="back_to_information_consumption" className="flex w-max items-center gap-3 cursor-pointer rounded py-2" onClick={() => handleTabChange(activeTab - 1)}>
          <ChevronLeft />

          <span>
            Voltar para produtos
          </span>
        </div>

        <div className="flex gap-6 grow">
          {card_type === "Client::Card::Fleet" && !category_bypass_consumption_usage_validations && (
            <div className="grow h-full flex flex-col gap-4">
              <p className="text-[20px] font-bold">
                Confirmação de segurança
              </p>

              <UnitTextField
                data-testid="consumption_usage_input"
                decimals={0}
                unit={unitStrategy.kilometers}
                maxValue={99_999_999}
                label="Quilometragem atual do equipamento"
                errorMessage={errors?.current_equipment_usage?.message}
                {...register('current_equipment_usage')}
              />
            </div>
          )}

          <div className="grow h-full flex flex-col gap-4 ml-auto">
            <p className="text-[20px] font-bold">
              Resumo da transação
            </p>

            <Table
              columns={defaultColumns}
              isLoadingData={isPending}
              page={1}
              rows={watchProducts}
              totalPages={1}
              totalCount={watchProducts.length}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-end gap-4">
        <div>
          <p className="text-[14px] font-light italic">
            Valor total
          </p>

          <p className="text-[18px] font-bold">
            {formatCurrency(watchTotalAmount || 0)}
          </p>
        </div>

        <div>
          <Button data-testid="confirm_transaction_consumption" type="submit">
            {isPending ? <Spinner className="h-6 mx-[23px] fill-white-800" /> : "Efetuar transação"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default TabResume;
